import { render, staticRenderFns } from "./MyCheckbox.vue?vue&type=template&id=46ab8358&scoped=true&"
import script from "./MyCheckbox.vue?vue&type=script&lang=ts&"
export * from "./MyCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./MyCheckbox.vue?vue&type=style&index=0&id=46ab8358&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ab8358",
  null
  
)

export default component.exports